import { QueryObserverBaseResult } from 'react-query'
import { Query } from '../../../hooks/queries'
import { useContrastQuery } from '../../../hooks/use-contrast-query'
import {
  CurrentUserProfile,
  getCurrentUserProfile
} from './requests/get-current-user-profile'

type UseCurrentUserProfile = (props: {
  organizationUuid: string
  enabled: boolean
}) => Pick<QueryObserverBaseResult, 'refetch'> & {
  isLoading: boolean
  currentUserProfile: undefined | CurrentUserProfile
}

export const useCurrentUserProfile: UseCurrentUserProfile = ({
  organizationUuid,
  enabled
}) => {
  const {
    data: currentUserProfile,
    isLoading,
    refetch
  } = useContrastQuery(
    [Query.CURRENT_USER_PROFILE, organizationUuid],
    getCurrentUserProfile,
    {
      organizationUuid
    },
    {
      enabled
    }
  )

  return {
    isLoading,
    refetch,
    currentUserProfile
  }
}
